import { Key } from '../@types/SettingChooseImage';

export const keys: Key[] = ['height', 'src', 'width'];
